import { render, staticRenderFns } from "./singleUpload.vue?vue&type=template&id=a83dba2e&scoped=true&"
import script from "./singleUpload.vue?vue&type=script&lang=ts&"
export * from "./singleUpload.vue?vue&type=script&lang=ts&"
import style0 from "./singleUpload.vue?vue&type=style&index=0&id=a83dba2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83dba2e",
  null
  
)

export default component.exports